import * as React from 'react';
import { IconButton } from '@grandvisionhq/common';
import { Icon } from '@grandvisionhq/icons';

const RemoveVoucherCode = ({ voucherCode , onRemove , 'data-t': dataT  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: "cart-totals__row",
        key: voucherCode
    }, /*#__PURE__*/ React.createElement("span", {
        className: "cart-totals__label"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "cart__applied-discount"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "cart__applied-discount-code"
    }, voucherCode), /*#__PURE__*/ React.createElement(IconButton, {
        className: "cart__applied-discount-button",
        onClick: onRemove,
        "data-t": dataT
    }, /*#__PURE__*/ React.createElement(Icon, {
        className: "cart__applied-discount-icon",
        name: "close",
        width: 12,
        height: 12
    })))), /*#__PURE__*/ React.createElement("span", {
        className: "cart-totals__value"
    }));
};

export { RemoveVoucherCode };
//# sourceMappingURL=RemoveVoucherCode.js.map
